import { Component, ElementRef, Inject, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { ConsultarListaNegraRequest, ImportarCamionRequest, itemsImportarCamion, ListarCamionRequest, TransaccionCamionRequest, TransaccionListaNegraRequest } from '../../../domain/request/mantenimiento-request';
import * as XLSX from 'xlsx-js-style';
import { firstValueFrom } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-mantenimiento-camion',
  templateUrl: './mantenimiento-camion.component.html',
  styleUrl: './mantenimiento-camion.component.css'
})
export class MantenimientoCamionComponent {
  @ViewChild('fileInput') fileInput: ElementRef
  constructor(private readonly mantcomercial: ComercialRepository, private readonly storage: StorageService,
    private util: UtilService, private messageService: MessageService, private confirmationService: ConfirmationService,
    @Optional() public config: DynamicDialogConfig,
    @Optional() public ref: DynamicDialogRef
  ) { }
  visible: boolean
  visiblebtn: boolean
  visibleImport: boolean
  visibleObsr: boolean
  codigo: number
  dato1 = 0
  condata: boolean = false
  selectedFileName: string = '';
  group: FormGroup
  groupPoppup: FormGroup
  groupPoppupObs: FormGroup
  dataTable: any[] = []
  dataTableImport: any[] = []
  listEmpresa: any[] = []
  listSucursal: any[] = []
  ListaTodosTipoBlo: any[] = []
  listaImportada: any[] = [];
  ListaTemp: any[] = []
  ListaContenedorExcel: itemsImportarCamion[] = [];
  ItemsExcel: itemsImportarCamion;
  ListaContenedorTemporal: itemsImportarCamion[] = [];
  data: any;
  visibleSoloNuevo: boolean = false
  metadataTable: newmetadate[] = [
    { field: 'spcM_Codigo', title: 'Código', inputType: 'text' }, { field: 'spcM_Placa', title: 'N° Placa', inputType: 'text' }
    //{ field: 'spcM_Activo', title: 'Estado', inputType: 'checkbox' }
    , { field: 'spcM_Bloqueado', title: 'Bloqueado', inputType: 'checkbox' }
  ]
  metadataTableImport: newmetadate[] = [
    { field: 'numero_placa', title: 'N° Placa', inputType: 'text' },
    {
      field: 'observacion', title: ' ', inputType: 'icono', iconI: (row: any) => row.conObservacion === true ? 'pi pi-eye' : 'pi pi-check-circle',
      pTooltip: (row: any) => row.conObservacion === true ? row.observacion : 'Sin Observación', toolTipPosition: 'left',
      colorIcon: (row: any) => row.conObservacion === true ? 'red' : 'green'
    }
    // { field: 'bloqueado', title: 'Bloqueado', inputType: 'text' },
    // { field: 'empresa', title: 'Empresa', inputType: 'text' }, { field: 'sucursal', title: 'Sucursal', inputType: 'text' }
  ]


  iniciarFormulario() {
    this.group = new FormGroup({
      numeroplaca: new FormControl(null, Validators.maxLength(11))
    })
    this.groupPoppup = new FormGroup({
      numeroplaca: new FormControl(null, [Validators.maxLength(11), Validators.required]),
      // empresa: new FormControl(null, null), sucursal: new FormControl(null, null)
    })
    this.groupPoppupObs = new FormGroup({
      tipobloqueo: new FormControl(null, Validators.required), observaciones: new FormControl(null, Validators.required),
    })
  }

  parametros: Parametros[] = []
  ListarParametros() {
    this.listEmpresa = this.parametros.slice().filter(r => r.tipo === 'EMPRESA')
    console.log('this.listEmpresa', this.listEmpresa)
    this.listSucursal = this.parametros.slice().filter(r => r.tipo === 'SUCURSAL')
    console.log('this.listSucursal', this.listSucursal)
    this.ListaTodosTipoBlo = this.parametros.slice().filter(r => r.tipo === 'TBLOQUEO')
  }

  async ngOnInit(): Promise<void> {
    this.data = this.config?.data;
    this.iniciarFormulario()

    // para recepcionar datos de otro componente
    console.log("data chofer", this.data)
    if (this.data?.modo === 'solo-nuevo') {
      this.visibleSoloNuevo = true;
      this.nuevo()
    }

    this.parametros = await this.util.getParametros()
    this.ListarParametros()
  }

  async buscar() {
    this.dataTable = await this.search()
  }

  async search(): Promise<any[]> {
    const values = this.group.value;
    const values2 = this.groupPoppup.value;
    const requestListar: ListarCamionRequest = {
      SPCM_Placa: (values.numerodoc === '' ? null : values.numeroplaca) === null ? values2.numeroplaca : values.numeroplaca
    };

    try {
      const response = await firstValueFrom(this.mantcomercial.ListarCamion(requestListar));
      if (response.datos.status === 200) {
        return response.datos.result;
      } else {
        console.error("⚠️ Backend respondió con error:", response.datos);
        return [];
      }
    } catch (error) {
      console.error("❌ Error en ListarChofer:", error);
      return [];
    }
  }

  nuevo() {
    this.visible = true
    this.visiblebtn = true
    this.codigo = null
    this.groupPoppup.reset()
  }

  editCamion(row) {
    this.visible = true
    this.visiblebtn = false
    this.codigo = row.spcM_Codigo
    this.groupPoppup.reset()
    if (row) {
      if (row.spcM_Placa) { this.groupPoppup.get('numeroplaca').setValue(row.spcM_Placa) }
      // if (row.empR_Codigo) {
      //   const e = this.listEmpresa.find(r => r.codigo === row.empR_Codigo.toString())?.codigo
      //   this.groupPoppup.get('empresa').setValue(e);
      // }
      // if (row.sucR_Codigo) {
      //   const s = this.listSucursal.find(r => r.codigo === row.sucR_Codigo.toString())?.codigo
      //   this.groupPoppup.get('sucursal').setValue(s);
      // }
    }
  }

  async TransaccionCamion(accion, row) {
    if (accion === 'D') {
      this.confirmationService.confirm({
        target: event.target,
        message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR?",
        icon: 'pi pi-exclamation-triangle',
        key: 'DT',
        accept: () => {
          const requestTransaccion = <TransaccionCamionRequest>{}
          requestTransaccion.SPCM_Codigo = this.codigo != null ? this.codigo : row.spcM_Codigo
          requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
          requestTransaccion.transaccion = accion
          this.mantcomercial.TransaccionCamion(requestTransaccion).subscribe((response) => {
            if (response.datos.status === 200) {
              this.util.ShowMessage({ titulo: '', mensaje: 'Se desactivó camión correctamente.', tipo: 'ok' })
              this.buscar()
              this.visible = false
            }
          })
        },
        reject: () => {
        }
      })
    } else if (accion === 'B') {
      this.groupPoppupObs.markAllAsTouched();
      const errorMessage: string[] = [];
      const validateFormGroup = (formGroup: FormGroup, groupName: string) => {
        Object.entries(formGroup.controls).forEach(([controlName, control]) => {
          if (control.invalid && control.errors?.['required']) {
            errorMessage.push(`El campo "${controlName}" en "${groupName}" es obligatorio.`);
          }
        });
      };

      validateFormGroup(this.groupPoppupObs, 'Observaciones');
      if (errorMessage.length > 0) {
        return
      }

      this.confirmationService.confirm({
        target: event.target,
        message: "¿ESTÁ SEGURO QUE DESEA BLOQUEAR ESTE CAMIÓN?",
        icon: 'pi pi-exclamation-triangle',
        key: 'DT',
        accept: () => {
          const values = this.groupPoppupObs.value
          const requestObservcion = <TransaccionListaNegraRequest>{}
          requestObservcion.SPLN_Tipo = 'M'
          requestObservcion.SPLN_Value = this.codigo
          requestObservcion.TIPO_TabBLO = 'BLO'
          requestObservcion.TIPO_CodBLO = values['tipobloqueo']
          requestObservcion.SPLN_Observaciones = values['observaciones']
          requestObservcion.AUDI_Usuario = this.storage.get('usuario')
          requestObservcion.SPLN_Activo = true
          requestObservcion.tipotransaccion = accion
          this.mantcomercial.TransaccionListaNegra(requestObservcion).subscribe((response) => {
            if (response.datos.status === 200) {
            }
          })
          const requestTransaccion = <TransaccionCamionRequest>{}
          requestTransaccion.SPCM_Codigo = this.codigo
          requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
          requestTransaccion.transaccion = accion
          this.mantcomercial.TransaccionCamion(requestTransaccion).subscribe((response) => {
            if (response.datos.status === 200) {
              this.util.ShowMessage({ titulo: '', mensaje: 'Se bloqueó camión correctamente.', tipo: 'ok' })
              this.buscar()
              this.visibleObsr = false
            }
          })
        },
        reject: () => {
        }
      })
    } else {
      this.groupPoppup.markAllAsTouched();
      const errorMessage: string[] = [];
      const validateFormGroup = (formGroup: FormGroup, groupName: string) => {
        Object.entries(formGroup.controls).forEach(([controlName, control]) => {
          if (control.invalid && control.errors?.['required']) {
            errorMessage.push(`El campo "${controlName}" en "${groupName}" es obligatorio.`);
          }
        });
      };

      validateFormGroup(this.groupPoppup, 'Poppup');
      if (errorMessage.length > 0) {
        return
      }

      const arreglo = await this.search()
      if (arreglo.length > 0 && accion === 'I') {
        this.codigo = arreglo[0].spcM_Codigo
        this.visiblebtn = false
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Registro Existente', detail: 'El camión ya se encuentra registrado.', sticky: true });
      } else {
        const values = this.groupPoppup.value
        const requestTransaccion = <TransaccionCamionRequest>{}
        requestTransaccion.SPCM_Codigo = this.codigo != null ? this.codigo : 0
        requestTransaccion.SPCM_Placa = values.numeroplaca != null ? values.numeroplaca : row.spcM_Placa
        requestTransaccion.SPCM_Activo = true
        requestTransaccion.SPCM_Bloqueado = false
        requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
        requestTransaccion.EMPR_Codigo = 1
        requestTransaccion.SUCR_Codigo = 1
        requestTransaccion.transaccion = accion
        this.mantcomercial.TransaccionCamion(requestTransaccion).subscribe((response) => {
          if (response.datos.status === 200) {
            if (this.visibleSoloNuevo == true) {
              this.enviarComponentePadre({ mensaje: "OK", nuevo_codigo: response.datos.codigo });
              return;
            }
            this.util.ShowMessage({ titulo: '', mensaje: 'Se guardaron los datos correctamente.', tipo: 'ok' })
            this.groupPoppup.reset(this.iniciarFormulario())
            this.buscar()
            this.visible = false
          }
        })
      }
    }
  }

  salir() {
    this.visible = false
    this.groupPoppup.reset()
    if (this.visibleSoloNuevo == true) {
      this.enviarComponentePadre({ mensaje: "Cerrar" });
    }
  }

  importExcel() {
    this.visibleImport = true
    this.listaImportada = []
    this.dataTableImport = []
    this.ListaTemp = []
  }
  disabledSave: boolean = false
  onFileChange(event) {
    const loadingScreen = this.util.showLoadingScreen({ message: "Importando Datos..." })
    this.dato1 = 1
    this.selectedFileName = ''
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        let newExcelData = []
        newExcelData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        const cabecerasprincipales = []
        this.metadataTableImport.forEach(r => {
          let dato = ''
          dato = r.field.toString()
          cabecerasprincipales.push(dato)
        })


        function procesarObjeto(objetoOriginal: Record<string, any>): Record<string, any> {
          const objetoModificado: Record<string, any> = {};
          for (const clave in objetoOriginal) {
            const claveMinusc = clave.toLowerCase();
            const claveSinTildes = claveMinusc.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const letras = claveSinTildes.replace(/[().''/]/g, '');
            const claveConGuiones = letras.replace(/\s/g, '_');
            objetoModificado[claveConGuiones] = objetoOriginal[clave];
          }
          return objetoModificado;
        }
        const arrayModificado = newExcelData.map(procesarObjeto);
        const arrayDeCabeceras = Object.keys(arrayModificado[2]);
        console.log(arrayDeCabeceras);
        const ListaImportacion = [];
        for (const row of arrayModificado) {
          const requestListar: ListarCamionRequest = { SPCM_Placa: row['numero_placa'] };

          let existe = false;
          let mensaje = null
          try {
            const response = await firstValueFrom(this.mantcomercial.ListarCamion(requestListar));
            existe = response?.datos?.result?.length > 0;
            mensaje = existe === true ? 'La placa ya se encuentra registrada' : null
          } catch (err) {
            console.error(`Error al validar placa ${row['numero_placa']}:`, err);
            mensaje = row['numero_placa']=== null || row['numero_placa'] === undefined || row['numero_placa']?.toString().trim() === "" ? "No se importó número de placa" :  null
          }

          ListaImportacion.push({
            numero_placa: row['numero_placa'],
            bloqueado: false,
            empresa: 1,
            sucursal: 1,
            conObservacion: mensaje === null ? false : true,
            observacion: mensaje
          });
        }
        this.listaImportada = [...this.listaImportada, ...ListaImportacion]
        this.dataTableImport = [...this.dataTableImport, ...ListaImportacion]
        console.log('LISTA IMPORTADA', this.listaImportada);
        this.condata = true
        if (this.fileInput) {
          this.fileInput.nativeElement.value = null;
        }
        this.disabledSave = this.listaImportada?.some(item => item.conObservacion === true);
        loadingScreen.close()
      } catch (error) {
        this.messageService.clear();
        this.messageService.add({ key: 'toast1', severity: 'warn', summary: 'Error', detail: 'Hubo un error en la importación.' });
        console.error('Error al procesar el archivo Excel:', error);
        loadingScreen.close()
      } finally {
        this.dato1 = 0
      }
    };

    reader.readAsArrayBuffer(file);
  }

  obtenerDatos(campo: string, tipo: string): string {
    let result
    if (tipo === 'EMPRESA') {
      result = this.listEmpresa.find(item => item.nombre.toUpperCase() === campo.toUpperCase())?.codigo
      return result
    } else {
      result = this.listSucursal.find(item => item.nombre.toUpperCase() === campo.toUpperCase())?.codigo
      return result
    }
  }

  selectFile() {
    document.getElementById('fileInput')?.click();
  }

  guardarExcel() {
    if (this.listaImportada.length == 0) {
      this.util.showMessage("Ingrese la información a guardar")
    } else {
      this.dato1 = 1
      let contador: number = 0
      let contadorgeneral: number = 0
      this.ListaContenedorExcel = []
      let j = 0
      this.listaImportada.forEach(element => {
        contador++
        contadorgeneral++
        this.ItemsExcel = <itemsImportarCamion>{}
        this.ItemsExcel.SPCM_Placa = element.numero_placa
        this.ItemsExcel.SPCM_Activo = true
        this.ItemsExcel.SPCM_Bloqueado = element.bloqueado
        this.ItemsExcel.AUDI_Usuario = this.storage.get('usuario')
        this.ItemsExcel.EMPR_Codigo = element.empresa ?? 1
        this.ItemsExcel.SUCR_Codigo = element.sucursal ?? 1

        this.ListaContenedorExcel.push(this.ItemsExcel)

      });

      this.ListaContenedorExcel
      const tamañoLote = 20000;
      const cantidadLotes = Math.ceil(this.listaImportada.length / tamañoLote);

      for (let i = 0; i < cantidadLotes; i++) {
        const inicio = i * tamañoLote;
        const fin = (i + 1) * tamañoLote;
        const lote = this.ListaContenedorExcel.slice(inicio, fin);

        // Agregar la solicitud del lote al array de observables
        const Requestimport: ImportarCamionRequest = {
          tabladetallecamion: lote
        };

        this.mantcomercial.ImportarCamion(Requestimport).subscribe(response => {
          if (response.datos.status === 200) {
            contador = 0
            this.ListaContenedorExcel = []
            this.util.NuevoMensaje('DATOS GUARDADOS', this.dataTableImport.length + ' Registros', 'check', null, false)
            this.visibleImport = false
            this.dataTableImport = []
            this.ListaTemp = []
            this.listaImportada = []
            this.buscar()
          }

        }, (errorServicio) => {
          this.util.NuevoMensaje('ERROR', (errorServicio.error.meta.mensaje).toUpperCase(), 'clear', null, false)

        })
      }
      this.dato1 = 0
    }
  }

  salirImportar() {
    this.visibleImport = false
  }
  verObsr: boolean
  abrirObservaciones(row) {
    this.visibleObsr = true
    this.groupPoppupObs.reset()
    this.codigo = row.spcM_Codigo
    if (row.spcM_Bloqueado === true) {
      this.verObsr = true
      const request: ConsultarListaNegraRequest = <ConsultarListaNegraRequest>{}
      request.SPLN_Tipo = "M"
      request.SPLN_Value = row.spcM_Codigo
      this.mantcomercial.ConsultarListaNegra(request).subscribe(response => {
        if (response.datos.status === 200) {
          this.groupPoppupObs.get('tipobloqueo').setValue(response.datos.result[0].tipO_CodBLO)
          this.groupPoppupObs.get('observaciones').setValue(response.datos.result[0].splN_Observaciones)
        }
      })
    } else {
      this.verObsr = false
    }
  }

  salirBloqueo() {
    this.visibleObsr = false
  }

  desbloquear(row) {
    this.confirmationService.confirm({
      target: event.target,
      message: "¿ESTÁ SEGURO QUE DESEA DESBLOQUEAR CAMIÓN?",
      icon: 'pi pi-exclamation-triangle',
      key: 'DT',
      accept: () => {
        const requestObservcion = <TransaccionListaNegraRequest>{}
        requestObservcion.SPLN_Tipo = 'M'
        requestObservcion.SPLN_Value = row.spcM_Codigo
        requestObservcion.SPLN_Activo = false
        requestObservcion.AUDI_Usuario = this.storage.get('usuario')
        requestObservcion.tipotransaccion = 'D'
        this.mantcomercial.TransaccionListaNegra(requestObservcion).subscribe((response) => {
          if (response.datos.status === 200) {
          }
        })
        const requestTransaccion = <TransaccionCamionRequest>{}
        requestTransaccion.SPCM_Codigo = row.spcM_Codigo
        requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
        requestTransaccion.transaccion = 'R'
        this.mantcomercial.TransaccionCamion(requestTransaccion).subscribe((response) => {
          if (response.datos.status === 200) {
            this.util.ShowMessage({ titulo: '', mensaje: 'Se desbloqueó camión correctamente.', tipo: 'ok' })
            this.buscar()
          }
        })
      },
      reject: () => {
      }
    })
  }
  exportExcel() {
    const headers = [
      ["Numero Placa"]
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(headers);
    const workbook: XLSX.WorkBook = { Sheets: { 'Placas Camión': worksheet }, SheetNames: ['Placas Camión'] };
    XLSX.writeFile(workbook, 'Placas Camión.xlsx');
  }

  deleteRow(row) {
    const index1 = this.listaImportada.findIndex(item => item.numero_placa === row.numero_placa);
    if (index1 > -1) {
      this.listaImportada.splice(index1, 1);
    } this.listaImportada = [...this.listaImportada]
    const index2 = this.dataTableImport.findIndex(item => item.numero_placa === row.numero_placa);
    if (index2 > -1) {
      this.dataTableImport.splice(index2, 1);
    }
    this.dataTableImport = [...this.dataTableImport]
    this.disabledSave = this.listaImportada?.some(item => item.conObservacion === true);
  }

  enviarComponentePadre(objeto: any) { this.ref.close(objeto); }

}
